// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.k5Qfc8TQln4cCTlJ43pH {
  border-bottom: 1px solid #C3CFE7;
}
.k5Qfc8TQln4cCTlJ43pH .card {
  border: none;
}
.k5Qfc8TQln4cCTlJ43pH .card:last-child {
  border-bottom: none;
}
.k5Qfc8TQln4cCTlJ43pH .card ._TN0wCvyOEVnnzwApzp4 {
  background-color: transparent;
  box-shadow: none;
  line-height: var(--bs-body-line-height);
  border: 0;
  text-align: right;
  justify-content: space-between;
  display: flex;
}
.k5Qfc8TQln4cCTlJ43pH .card ._TN0wCvyOEVnnzwApzp4 .fZPNvtTrklhXFTfO_O1K:focus {
  box-shadow: none;
  outline: none;
}
.k5Qfc8TQln4cCTlJ43pH .card ._TN0wCvyOEVnnzwApzp4 .fZPNvtTrklhXFTfO_O1K svg {
  stroke: #0C3058;
  transition: transform 0.3s ease;
}
.k5Qfc8TQln4cCTlJ43pH .card ._TN0wCvyOEVnnzwApzp4 .fZPNvtTrklhXFTfO_O1K.AVV3JYcOHIKWvB6yMi2M svg {
  transform: rotate(180deg);
}
.k5Qfc8TQln4cCTlJ43pH .card ._TN0wCvyOEVnnzwApzp4 .T9TtCsTBGHMnUGD2MTox {
  font-size: 16px;
  font-weight: 500;
  color: #0068F5;
}
.k5Qfc8TQln4cCTlJ43pH .card .QamKHSLbP3IDxrxkkDnM .Qlrny7RrrtfVWygFs0VA {
  margin-right: 28px;
  max-height: 280px;
  overflow-y: auto;
  padding-left: 6px;
  margin-left: -6px;
  /* Custom scrollbar */
}
.k5Qfc8TQln4cCTlJ43pH .card .QamKHSLbP3IDxrxkkDnM .Qlrny7RrrtfVWygFs0VA::-webkit-scrollbar {
  width: 6px;
}
.k5Qfc8TQln4cCTlJ43pH .card .QamKHSLbP3IDxrxkkDnM .Qlrny7RrrtfVWygFs0VA::-webkit-scrollbar-track {
  background: color-mix(in srgb, var(--scrollbar-color), transparent 95%);
  border-radius: 10px;
}
.k5Qfc8TQln4cCTlJ43pH .card .QamKHSLbP3IDxrxkkDnM .Qlrny7RrrtfVWygFs0VA::-webkit-scrollbar-thumb {
  background: color-mix(in srgb, var(--scrollbar-color), transparent 30%);
  border-radius: 10px;
}
.k5Qfc8TQln4cCTlJ43pH .card .QamKHSLbP3IDxrxkkDnM .Qlrny7RrrtfVWygFs0VA::-webkit-scrollbar-thumb:hover {
  background: color-mix(in srgb, var(--scrollbar-color), transparent 0%);
}
.k5Qfc8TQln4cCTlJ43pH .card .QamKHSLbP3IDxrxkkDnM .Qlrny7RrrtfVWygFs0VA .HORFULV7jcGJNkIcZtBd {
  margin-bottom: 4px;
  margin-top: 4px;
}
.k5Qfc8TQln4cCTlJ43pH .card .card-body {
  padding: 0.75rem 0.5rem 0.75rem 0rem;
}
.HORFULV7jcGJNkIcZtBd {
  display: flex;
  align-items: center;
  margin: 0;
  margin-left: 3px;
}

.tYpYfSoPTyKI4ESWj8dz {
  position: relative;
}
.tYpYfSoPTyKI4ESWj8dz .qSujNndQT5d10DZCRZCG {
  margin-right: 0;
  cursor: pointer;
  width: 20px;
  height: 20px;
  appearance: none;
  -webkit-appearance: none;
  border-radius: 5px;
  border: 1px solid rgba(12, 48, 88, 0.7);
  position: relative;
}
.tYpYfSoPTyKI4ESWj8dz .qSujNndQT5d10DZCRZCG:checked {
  border: 1px solid #0079FF;
  box-shadow: none;
  background-color: #0079FF;
}
.tYpYfSoPTyKI4ESWj8dz .qSujNndQT5d10DZCRZCG:checked + .O4idpeKrU8mVgo04g_5z svg {
  display: flex;
  opacity: 1;
}
.tYpYfSoPTyKI4ESWj8dz .qSujNndQT5d10DZCRZCG:checked + .O4idpeKrU8mVgo04g_5z.WShm8wIzGxUF6Rad4OsD svg {
  stroke: #ffffff;
}
.tYpYfSoPTyKI4ESWj8dz .qSujNndQT5d10DZCRZCG:focus {
  border: 1px solid #0079FF;
  box-shadow: none;
}
.tYpYfSoPTyKI4ESWj8dz .O4idpeKrU8mVgo04g_5z svg {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  opacity: 0;
  color: white;
  fill: white;
}

.Ehnb9jZekxdmblcDp7U1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
  font-size: 16px;
  color: #0C3058;
  margin-right: 8px;
  margin-bottom: 2px;
}`, "",{"version":3,"sources":["webpack://./GeneralComponents/SearchResults/searchFilters/categoriesFilter/CategoryFilter.module.scss"],"names":[],"mappings":"AAAA;EACI,gCAAA;AACJ;AAEI;EACI,YAAA;AAAR;AAEQ;EACI,mBAAA;AAAZ;AAGQ;EACI,6BAAA;EACA,gBAAA;EACA,uCAAA;EACA,SAAA;EACA,iBAAA;EACA,8BAAA;EACA,aAAA;AADZ;AAIgB;EACI,gBAAA;EACA,aAAA;AAFpB;AAKgB;EACI,eAAA;EACA,+BAAA;AAHpB;AAMgB;EACI,yBAAA;AAJpB;AAQY;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AANhB;AAWY;EACI,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EAEA,qBAAA;AAVhB;AAWgB;EACI,UAAA;AATpB;AAYgB;EACI,uEAAA;EACA,mBAAA;AAVpB;AAagB;EACI,uEAAA;EACA,mBAAA;AAXpB;AAaoB;EACI,sEAAA;AAXxB;AAegB;EACI,kBAAA;EACA,eAAA;AAbpB;AAkBQ;EACI,oCAAA;AAhBZ;AAwBA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AAtBJ;;AAyBA;EACI,kBAAA;AAtBJ;AAwBI;EACI,eAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,wBAAA;EACA,kBAAA;EACA,uCAAA;EACA,kBAAA;AAtBR;AAwBQ;EACI,yBAAA;EACA,gBAAA;EACA,yBAAA;AAtBZ;AA0BgB;EACI,aAAA;EACA,UAAA;AAxBpB;AA4BoB;EACI,eAAA;AA1BxB;AAgCQ;EACI,yBAAA;EACA,gBAAA;AA9BZ;AAmCQ;EACI,kBAAA;EACA,QAAA;EACA,gCAAA;EACA,oBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;AAjCZ;;AAsCA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AAnCJ","sourcesContent":[".category-filter {\r\n    border-bottom: 1px solid #C3CFE7;\r\n\r\n    // Accordion customization\r\n    :global(.card) {\r\n        border: none;\r\n\r\n        &:last-child {\r\n            border-bottom: none;\r\n        }\r\n\r\n        .card-header {\r\n            background-color: transparent;\r\n            box-shadow: none; // Remove any default shadow\r\n            line-height: var(--bs-body-line-height);\r\n            border: 0;\r\n            text-align: right;\r\n            justify-content: space-between;\r\n            display: flex;\r\n\r\n            .category-chevron {\r\n                &:focus {\r\n                    box-shadow: none;\r\n                    outline: none;\r\n                }\r\n\r\n                svg {\r\n                    stroke: #0C3058;\r\n                    transition: transform 0.3s ease;\r\n                }\r\n\r\n                &.open svg {\r\n                    transform: rotate(180deg);\r\n                }\r\n            }\r\n\r\n            .category-link {\r\n                font-size: 16px;\r\n                font-weight: 500;\r\n                color: #0068F5;\r\n            }\r\n        }\r\n\r\n        .card-container {\r\n            .sub-categories {\r\n                margin-right: 28px;\r\n                max-height: 280px;\r\n                overflow-y: auto;\r\n                padding-left: 6px; // Space for scrollbar\r\n                margin-left: -6px; // Pull scrollbar outside content area\r\n\r\n                /* Custom scrollbar */\r\n                &::-webkit-scrollbar {\r\n                    width: 6px;\r\n                }\r\n\r\n                &::-webkit-scrollbar-track {\r\n                    background: color-mix(in srgb, var(--scrollbar-color), transparent 95%);\r\n                    border-radius: 10px;\r\n                }\r\n\r\n                &::-webkit-scrollbar-thumb {\r\n                    background: color-mix(in srgb, var(--scrollbar-color), transparent 30%);\r\n                    border-radius: 10px;\r\n\r\n                    &:hover {\r\n                        background: color-mix(in srgb, var(--scrollbar-color), transparent 0%);\r\n                    }\r\n                }\r\n\r\n                .form-check {\r\n                    margin-bottom: 4px;\r\n                    margin-top: 4px;\r\n                }\r\n            }\r\n        }\r\n\r\n        :global(.card-body) {\r\n            padding: 0.75rem 0.5rem 0.75rem 0rem;\r\n        }\r\n    }\r\n\r\n    // Responsive adjustments\r\n    @media (max-width: 767.98px) {}\r\n}\r\n\r\n.form-check {\r\n    display: flex;\r\n    align-items: center;\r\n    margin: 0;\r\n    margin-left: 3px;\r\n}\r\n\r\n.form-check-wrap {\r\n    position: relative;\r\n\r\n    .form-check-input {\r\n        margin-right: 0;\r\n        cursor: pointer;\r\n        width: 20px;\r\n        height: 20px;\r\n        appearance: none;\r\n        -webkit-appearance: none;\r\n        border-radius: 5px;\r\n        border: 1px solid rgba(12, 48, 88, 0.7);\r\n        position: relative;\r\n\r\n        &:checked {\r\n            border: 1px solid #0079FF;\r\n            box-shadow: none;\r\n            background-color: #0079FF;\r\n\r\n            // Target the overlay sibling when input is checked\r\n            &+.custom-icon-overlay {\r\n                svg {\r\n                    display: flex;\r\n                    opacity: 1;\r\n                }\r\n\r\n                &.check-minus {\r\n                    svg {\r\n                        stroke: #ffffff;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        &:focus {\r\n            border: 1px solid #0079FF;\r\n            box-shadow: none;\r\n        }\r\n    }\r\n\r\n    .custom-icon-overlay {\r\n        svg {\r\n            position: absolute;\r\n            top: 50%;\r\n            transform: translate(-50%, -50%);\r\n            pointer-events: none; // Allows clicking the checkbox through the icon\r\n            opacity: 0; // Hidden until checked\r\n            color: white;\r\n            fill: white;\r\n        }\r\n    }\r\n}\r\n\r\n.form-check-label {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    width: 100%;\r\n    cursor: pointer;\r\n    font-size: 16px;\r\n    color: #0C3058;\r\n    margin-right: 8px;\r\n    margin-bottom: 2px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"category-filter": `k5Qfc8TQln4cCTlJ43pH`,
	"card-header": `_TN0wCvyOEVnnzwApzp4`,
	"category-chevron": `fZPNvtTrklhXFTfO_O1K`,
	"open": `AVV3JYcOHIKWvB6yMi2M`,
	"category-link": `T9TtCsTBGHMnUGD2MTox`,
	"card-container": `QamKHSLbP3IDxrxkkDnM`,
	"sub-categories": `Qlrny7RrrtfVWygFs0VA`,
	"form-check": `HORFULV7jcGJNkIcZtBd`,
	"form-check-wrap": `tYpYfSoPTyKI4ESWj8dz`,
	"form-check-input": `qSujNndQT5d10DZCRZCG`,
	"custom-icon-overlay": `O4idpeKrU8mVgo04g_5z`,
	"check-minus": `WShm8wIzGxUF6Rad4OsD`,
	"form-check-label": `Ehnb9jZekxdmblcDp7U1`
};
export default ___CSS_LOADER_EXPORT___;
